"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageDescriptor = void 0;
var stringUtils_1 = require("../../utils/stringUtils");
var ImageDescriptor = /** @class */ (function () {
    function ImageDescriptor(descr) {
        this.descr = descr;
    }
    ImageDescriptor.prototype.getFullImageDescriptor = function () {
        try {
            if (!this.descr.relativeUrl && this.descr.url) {
                // get relative url from name
                this.descr.relativeUrl = stringUtils_1.parseImageName(this.descr.url);
            }
            if (!this.descr.sourceWidth || !this.descr.sourceHeight) {
                // get sourceWidth || sourceHeight from name
                var _a = stringUtils_1.parseWidthHeight(this.descr.url), width = _a.width, height = _a.height;
                this.descr.sourceWidth = width || this.descr.targetWidth || 100;
                this.descr.sourceHeight = height || this.descr.targetHeight || 100;
            }
        }
        catch (e) {
            console.log('Error in ImageDescriptor.setFullImageDescriptor');
        }
        return this.descr;
    };
    ImageDescriptor.fromUrl = function (url) {
        var descriptor = {
            targetHeight: 0,
            targetWidth: 0,
            url: url,
        };
        var imgD = new ImageDescriptor(descriptor);
        return imgD.getFullImageDescriptor();
    };
    return ImageDescriptor;
}());
exports.ImageDescriptor = ImageDescriptor;
//# sourceMappingURL=ImageDescriptor.js.map